export default __webpack_public_path__ + "static/media/cs_icon_08.83eaf1db.png";